// src/components/auth/ProtectedRoute.tsx
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
    adminOnly?: boolean;
}

export function ProtectedRoute({ adminOnly = false }: ProtectedRouteProps) {
    const { user } = useAuth();

    // 1. Se o usuário não está logado
    if (!user) {
        // Se a rota é de admin, vai para o login de admin. Senão, para o login de usuário.
        const loginPath = adminOnly ? '/admin/login' : '/login';
        return <Navigate to={loginPath} />;
    }

    // 2. Se a rota é apenas para admin, mas o usuário não é admin
    if (adminOnly && user.role !== 'ADMIN') {
        // Redireciona para uma página de "não autorizado" ou para a home
        return <Navigate to="/" />;
    }

    // Se passou por todas as verificações, permite o acesso
    return <Outlet />;
}